import 'bootstrap/dist/js/bootstrap.min.js';
import {createPopper} from '@popperjs/core';
// Swiper
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Cookie from 'js-cookie';

document.addEventListener('DOMContentLoaded', function () {
  // init when .swiper exists
  if (document.querySelector('.swiper')) {
    const swiper = new Swiper('.swiper', {
      //spaceBetween: 30,
      effect: 'fade',
      autoplay: {
        delay: 5000,
      },
      speed: 1000,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });

    document.querySelector('.stopbtn').addEventListener('click', (ev) => {
      console.log(ev.target);
      const _class = ev.target.classList;
      if (_class.contains('stop')) {
        _class.remove('stop');
        _class.add('start');
        swiper.autoplay.stop();
      } else {
        _class.remove('start');
        _class.add('stop');
        swiper.autoplay.start();
      }
    });
  }

  // SPで hover クラスを付与
  document.querySelectorAll('.js_h').forEach((jsh) => {
    ['mouseenter', 'touchstart', {passive: true}].forEach((event) => {
      jsh.addEventListener(event, () => {
        jsh.classList.add('hover');
      });
    });
    ['mouseleave', 'touchend', {passive: true}].forEach((event) => {
      jsh.addEventListener(event, () => {
        jsh.classList.remove('hover');
      });
    });
  });

  // IntersectionObserver
  const scrollCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.setAttribute('aria-hidden', 'false');
      } else {
        entry.target.setAttribute('aria-hidden', 'true');
      }
    });
  };

  const observers = [];
  const sections = document.querySelectorAll('.data-scroll-section');
  sections.forEach((e, i) => {
    observers[i] = new IntersectionObserver(scrollCallback);
    observers[i].observe(e);
  });

// 教員一覧 Local nav
  if (document.querySelector('.scroll-intersection')) {
    const boxes = document.querySelectorAll('.staff-list');

    const options = {
      root: null, // 今回はビューポートをルート要素とする
      // rootMargin: '0px 0px -70% 0px',
      rootMargin: '-40% 0px',
      threshold: 0, // 閾値は0
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);

    boxes.forEach((box) => {
      observer.observe(box);
    });

    function doWhenIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activateIndex(entry.target);
        }
      });
    }

    function activateIndex(element) {
      const currentActiveIndex = document.querySelector('#staff-list-nav .active');
      if (currentActiveIndex !== null) {
        currentActiveIndex.classList.remove('active');
      }

      const newActiveIndex = document.querySelector(`a[href='#${element.id}']`);
      newActiveIndex.classList.add('active');
    }
  }

// header 高さ分アンカーリンクをずらす
  document.querySelectorAll('.staff-list-local-nav-container a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (event) {
      event.preventDefault();

      const target = document.querySelector(this.getAttribute('href'));
      const headerHeight = document.querySelector('.header-container').offsetHeight;

      window.scrollTo({
        //       top: target.offsetTop - headerHeight,
        top: target.offsetTop,
        behavior: 'smooth',
      });
    });
  });

// header 高さ分アンカーリンクをずらす　※_base.scss html
// var pagelink = document.querySelectorAll('.header-container');
// for (var i = 0; i < pagelink.length; i++) {
//   pagelink[i].addEventListener('click', smoothScroll, false);
// }
// function smoothScroll(e) {
//   e.preventDefault();
//   var pagelinkId = e.target.hash;
//   var pagelinkSection = document.querySelector(pagelinkId);
//   var scrollPosition = window.pageYOffset + pagelinkSection.getBoundingClientRect().top;
//   window.scrollTo({
//     top: scrollPosition,
//     behavior: 'smooth',
//   });
// }

  // stakeholder-nav ※front-page 以外
  if (document.querySelector('.stakeholder-btn')) {
    const btn = document.querySelector('.stakeholder-btn');
    const nav = document.querySelector('.stakeholder-container');

    //   window.addEventListener('load', function () {
    // ページを読み込み終わったら実行する処理
    //     setTimeout(function () {
    //       nav.classList.add('closed');
    //       btn.setAttribute('aria-expanded', 'false');
    //       btn.setAttribute('aria-label', 'メニューを開く');
    //     }, 1000);
    //   });

    btn.addEventListener('click', () => {
      nav.classList.toggle('closed');

      if (nav.classList.contains('closed')) {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'メニューを開く');
      } else {
        btn.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-label', 'メニューを閉じる');
      }
    });
  }

  const yearSelect = document.getElementById('selector-archive-fiscal-year');
  if (yearSelect != null) {
    yearSelect.addEventListener(
      'change',
      function () {
        window.location.href = this.value;
      },
      false
    );
  }

  // Cookie Consent
  const THE_COOKIE = '_privacy_consent';
  const consentPanel = document.getElementById('enableCookies');
  const consent = Cookie.get(THE_COOKIE);
  const COOKIE_LIFETIME = 7 * 4 * 3; // 7 days * 4 weeks * 3 months

  if (undefined === consent) {
    consentPanel.style.display = 'block';
  } else {
    consentPanel.style.display = 'none';
  }

  if (consentPanel.style.display === 'block') {
    document.getElementById('consent-agreed').addEventListener('click', function () {
      console.log('agreed');
      Cookie.set(THE_COOKIE, 'true', {expires: COOKIE_LIFETIME});
      consentPanel.style.display = 'none';
      location.reload();
    });

    // document.getElementById('consent-disagreed').addEventListener('click', function () {
    //   console.log('disagreed');
    //   Cookie.set(THE_COOKIE, 'false', {expires: COOKIE_LIFETIME});
    //   consentPanel.style.display = "none";
    // });
  }

  const btnCookieReactivate = document.querySelector(
    '.btn-call-cookie-accept > a.wp-block-button__link'
  );
  if (btnCookieReactivate !== null) {
    btnCookieReactivate.addEventListener('click', function (ev) {
      console.log('reactivate cookie');
      Cookie.set(THE_COOKIE, 'true', {expires: COOKIE_LIFETIME});
      consentPanel.style.display = 'none';
      location.reload();
    });
  }


  // if cookie "_privacy_consent" is not set or false, delete all element with class "wp-block-embed__wrapper"
  if (undefined === consent || false === consent) {
    document.querySelectorAll('.wp-block-embed__wrapper > iframe').forEach((el) => {
      // 1: protocol, 2: subdomain, 3: domain, 4: path, 5: video code, 6: query string
      let parsed = el.src.match(
        /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|live\/|v\/)?)([\w\-]+)(\S+)?$/
      );
      if (parsed !== null && parsed[6] !== undefined) {
        let id = parsed[6];
        el.parentNode.innerHTML =
          `<img src="https://img.youtube.com/vi/${id}/maxresdefault.jpg" alt="動画サムネール">` +
          '<div class="no-yt-player-for-no-cookie"><p>Cookieが無効なため、動画プレーヤーの埋め込みを停止しております。<br>以下のURLからご視聴ください。<br>' +
          `<a href="https://www.youtube.com/watch?v=${id}" target="_blank" rel="noopener noreferrer" class="youtube-link">https://www.youtube.com/watch?v=${id}</a>` +
          '</p></div>';
        el.remove();
      }
    });
  }

  // if cookie "_privacy_consent" is not set or false, delete all iframe with id "swap-google-map"
    if (undefined === consent || false === consent) {
        document.querySelectorAll('#swap-google-map').forEach((el) => {
            el.parentNode.appendChild(
              document.createElement('div')).innerHTML = "Cookieが無効なため、Googleマップの埋め込みを停止しております。" +
              "<br>以下のURLからご覧ください。" +
              "<br><a href='https://maps.app.goo.gl/oiQMx9DEouwuwHKB9' target='_blank' rel='noopener noreferrer'>https://maps.app.goo.gl/oiQMx9DEouwuwHKB9</a>";
        el.remove();
        });
    }

});
